import Vue from 'vue'
import Vuex from 'vuex'
import LookupService from "../services/LookupService";
import UnitService from "../services/UnitService";
import AvailabilityService from "../services/AvailabilityService";
import RateService from "../services/RateService";
import AmenitiesService from "../services/AmenitiesService";
import moment from "moment";


Vue.use(Vuex)

export const store = new Vuex.Store({
    // from Vue component
    actions: {
        // get Categories
        getCategories: ({ commit }, categoriesParams) => {
            LookupService.getCategories(categoriesParams.auth_token)
                .then(response => {
                    // // console.log(response.data)
                    commit('SET_CATEGORIES', response.data)
                })
        },
        getUnits: ({ commit }, unitParams) => {
            UnitService.getUnits(unitParams.auth_token)
                .then(response => {
                    // // console.log(response.data)
                    commit('SET_UNITS', response.data)
                })
        },
        getAvailability: ({ commit }, availabilityParams) => {
            AvailabilityService.getavailabilities(availabilityParams.auth_token)
                .then(response => {
                    // // console.log(response.data)
                    commit('SET_AVAILABILITY', response.data)
                })
        },
        getRates: ({ commit }, ratesParams) => {
            RateService.getRates(ratesParams.auth_token)
                .then(response => {
                    // // console.log(response.data)
                    commit('SET_RATES', response.data)
                })
        },
        getAmenities: ({ commit }, amenitiesParams) => {
            AmenitiesService.getAmenities(amenitiesParams.auth_token)
                .then(response => {
                    // // console.log(response.data)
                    commit('SET_AMENITIES', response.data)
                })
        },
    },
    mutations: {
        'SET_CATEGORIES'(state, data) {
            state.categories = data
        },
        'SET_UNITS'(state, data) {
            state.units = data
        },
        'SET_AVAILABILITY'(state, data) {
            state.availability = data
        },
        'SET_RATES'(state, data) {
            state.rates = data
        },
        'SET_AMENITIES'(state, data) {
            state.amenities = data
        },
        'SET_RATES'(state, data) {
            // process data into single day(s)
            let dailyRates = [];
            let otherRates = [];
            if (parseInt(data.length, 10) > 0) {
                data.forEach(rateItem => {
                    if (parseInt(rateItem.price_type, 10) == 1) {
                        dailyRates.push(rateItem);
                    } else {
                        otherRates.push(rateItem);
                    }
                })
            }
            // set state
            state.dailyRates = dailyRates;
            state.otherRates = otherRates; // deprecate this!! at some point
        },
    },
    state: {
        search: [],
        categories: [],
        units: [],
        availability: [],
        rates: [],
        amenities: []
    },
    getters: {
        search: (state) => {
            return state.search
        },
        categories: (state) => {
            return state.categories
        },
        units: (state) => (category) => {
            return state.units
                .filter(units => (units.category_id == category && category > 0) || category == 0)
        },
        unitsSearch: (state) => (category, partySize) => {
            return state.units
                .filter(units => (units.category_id == category && category > 0) || category == 0)
                .filter(units => (units.occupancy >= partySize && partySize > 0) || partySize == 0)
                .filter(unit => unit.active_flag == 1)
                .filter(unit => unit.archive_flag == 0)
                .filter(unit => unit.online_flag == 1)
        },
        availability: (state) => (formattedFrom, formattedTo, category) => {
            return state.availability
                .filter(availability => moment(availability.day).format('YYYY-MM-DD') >= formattedFrom)
                .filter(availability => moment(availability.day).format('YYYY-MM-DD') <= formattedTo)
                .filter(availability => (availability.category_id == category && category > 0) || category == 0)
        },
        rates: (state) => (ratesFormattedFrom, formattedTo) => {
            return state.rates
                // .filter(rates => rates.category_id == categorySelected)
                .filter(rates => moment(rates.day).format('YYYY-MM-DD') >= ratesFormattedFrom)
                .filter(rates => moment(rates.day2).format('YYYY-MM-DD') <= formattedTo)
        },
        dailyRates: (state) => (unitId, fromDate, toDate) => {
            return state.dailyRates
                .filter(rate => (rate.unit_id == unitId && unitId > 0) || unitId == 0)
                .filter(rate => ((moment(rate.day) >= moment(fromDate) && moment(rate.day) <= moment(toDate)) || (moment(rate.day2) >= moment(fromDate) && moment(rate.day2) <= moment(toDate)) || (moment(fromDate) >= moment(rate.day) && moment(fromDate) <= moment(rate.day2))))
                .filter(rate => (rate.price_type == 1))
            },
        otherRates: (state) => (unitId, type) => {
            return state.otherRates
                .filter(rate => rate.unit_id == unitId)
                .filter(rate => ((type == 'weekly' && rate.price_type == 2) || (type == 'break' && rate.price_type == 3)))
        },
        amenitySearch: (state) => {
            return state.amenities
        },
        categoryParentUnits: (state) => (category_id) => {
            return state.units
                .filter(unit => unit.category_id == category_id)
                .filter(unit => unit.parent_id == 0)
                .filter(unit => unit.active_flag == 1)
                .filter(unit => unit.archive_flag == 0)
        },
         // used by Search to Email
        //  unitsSearch: (state) => (selectedUnit, petSelected, bedrooms, partySize) => {
        //     return state.units
        //         // this eliminates time based which is availabilty type 4.
        //         .filter(unit => unit.availability_type != 4)
        //         .filter(unit => unit.active_flag == 1)
        //         .filter(unit => unit.archive_flag == 0)
        //         .filter(unit => (unit.id == selectedUnit && selectedUnit > 0) || selectedUnit == 0)
        //         .filter(unit => (unit.pets_flag == petSelected && petSelected == 1) || petSelected == 0)
        //         .filter(unit => (unit.bedrooms == bedrooms && bedrooms > 0) || bedrooms == 0)
        //         .filter(unit => (unit.occupancy >= partySize && partySize > 0) || partySize == 0)
        // },
    }
})
